import {
    Ga4PricedItem,
    GA4Tracking,
    getGa4Items,
    gtmSendEvent,
} from "@wojo/analytics";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import { useTripBuilder } from "../context/TripBuilderContext";

export const useTripBuilderAnalytics = () => {
    const { draftQuote } = useTripBuilderQuote();
    const { departure } = useTripBuilder();
    const ecommerceItem = {
        item_brand: process.env.NEXT_PUBLIC_BUSINESS_CODE,
        item_category3: draftQuote?.order.gcDepartureId ? "Groups" : "Indies",
        tourCode: departure?.tourCode || "",
    };

    const addToCart = (
        totalPrice: number,
        items: Ga4PricedItem[],
        ga4Tracking?: GA4Tracking,
    ) => {
        const itemsWithCommonProps = getGa4Items(items, ecommerceItem);
        gtmSendEvent({
            event: "add_to_cart",
            ecommerce: {
                currency: draftQuote?.order.currencyCode,
                value: totalPrice,
                items: itemsWithCommonProps,
            },
            ga4Tracking,
        });
    };

    const removeFromCart = (
        totalPrice: number,
        items: Ga4PricedItem[],
        ga4Tracking?: GA4Tracking,
    ) => {
        const itemsWithCommonProps = getGa4Items(items, ecommerceItem);
        gtmSendEvent({
            event: "remove_from_cart",
            ecommerce: {
                currency: draftQuote?.order.currencyCode,
                value: totalPrice,
                items: itemsWithCommonProps,
            },
            ga4Tracking,
        });
    };

    return {
        addToCart,
        removeFromCart,
    };
};
